<template>
    <div class="thirdparty">
      <div class="login-other">
        <p class="lg-tit">第三方登录</p>
      </div>
      <div class="login-other">
        <!--http://oauth.passport.cntv.cn/OAuthQzoneClient/OAuthQZoneClientServlet.do?method=login&cntv_callback=http://d.site.ishow.cctv.com-->
        <a class="os OAuthQzoneClient" href="https://oauth.passport.cntv.cn/OAuthQzoneClient/OAuthQZoneClientServlet.do?method=login&cntv_callback=https://act.ishow.cctv.com/h5/detail/100066" >
          <img src="../../../static/dist/img/icon-qq.png">
        </a>
        <a class="os OAuthSinaClient" href="https://oauth.passport.cntv.cn/OAuthSinaClient/OAuthSinaClientServlet.do?cntv_callback=https://act.ishow.cctv.com/h5/detail/100066">
          <img src="../../../static/dist/img/icon-blog.png">
        </a>
        <a class="os OauthAlipay" href="https://reg.cctv.com/OauthAlipay/OauthAlipayServlet.action?method=login&cntv_callback=https://act.ishow.cctv.com/h5/detail/100066">
          <img src="../../../static/dist/img/icon-zfb.png">
        </a>
      </div>
    </div>
</template>

<script>
    export default {
        name: "thirdparty",
        data() {
            return {
              loadUrl: ''
            }
        },
        methods: {
            // 操作按钮事件
        },
        created: function () {

        },
        mounted: function () {
            // 操作DOM
          this.loadUrl =  window.location.href
          $('.OAuthQzoneClient').prop('href','https://oauth.passport.cntv.cn/OAuthQzoneClient/OAuthQZoneClientServlet.do?method=login&cntv_callback=' + this.loadUrl )
          $('.OAuthSinaClient').prop('href','https://oauth.passport.cntv.cn/OAuthSinaClient/OAuthSinaClientServlet.do?cntv_callback=' + this.loadUrl )

          // $('.OAuthQzoneClient').prop('href','https://reg.cctv.com/OAuthQzoneClient/OAuthQZoneClientServlet.do?method=login&cntv_callback=' + this.loadUrl )
         // $('.OAuthSinaClient').prop('href','https://reg.cctv.com/OAuthSinaClient/OAuthSinaClientServlet.do?method=login&cntv_callback=' + this.loadUrl )
          $('.OauthAlipay').prop('href','https://reg.cctv.com/OauthAlipay/OauthAlipayServlet.action?method=login&cntv_callback=' + this.loadUrl )
        }
    }
</script>

<style scoped>
  .thirdparty{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/loginAlert/thirdparty.vue